import React from "react";
import styled from "@emotion/styled";
// import { AccommodationAcquisitionForm } from './AccommodationAcquisitionForm';
import { Contact } from './Contact';

import withTranslator from "../..//Translator/withTranslation";

const Container = styled.div`
    position: relative;
`;

const  AccommodationAcquisitionBackground = styled.div`
    position:absolute;background: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url('https://www.ocu.org/-/media/ocu/seo/alquiler/datos-comprar-casa%201.jpg') 0 -140px; 
    background-position:0px 0px; 
    background-repeat: no-repeat; 
    background-size:cover; 
    min-height:600px; 
    clip-path: ellipse(100% 100% at 50% 0); 
    -webkit-clip-path: ellipse(100% 100% at 50% 0); 
    margin-bottom:100px; 
    width:100%;
    top: -30%;
    z-index: -1;
    @media(max-width:400px) {
        min-height:525px;
    }
`;
const HeadLine = styled.div`
    font-size:3em;
    line-height: 1.7em;
    text-shadow: 2px 2px #000;
    @media (max-width:1200px) {
        font-size:2.6em;
        line-height:2em;
        text-align:center;
    }
    @media (max-width:768px) {
        font-size:2em;
        line-height:1.5em;
        text-align:center;
    }
    @media (max-width:400px) {
        font-size:1.5em;
        line-height:1.5em;
        text-align:center;
    }
`;

const ElementRow = styled.div`
    min-height:500px;
    @media (max-width:400px) {
        min-height:50vh;
        align-items:baseline;
        padding-top:1em!important;
    }
`;

const HeroContainer = styled.div`
    @media (max-width:400px) {
        min-height: 450px;
    }
`;
const AccommodationAcquisitionInnerComponent = (props) => {
    return (
        <HeroContainer className="">
            <AccommodationAcquisitionBackground />
            <Container className="container" >
                <ElementRow className="row items-fstart pt-lg-5 pt-md-3 pt-1  ">
                        <div className="col-md-12 col-lg-6 col-xl-6  white flex  px-lg-5 px-md-3 px-lg-0 pb-3">
                            <HeadLine className="white font-200 font-w600">{props.t('let_your_holiday_home')}</HeadLine>
                        </div>
                        <div className="col-md-12 col-lg-6 flex flex-column">
                            {/* <AccommodationAcquisitionForm {...props} /> */}
                            <Contact {...props} />
                        </div>
                </ElementRow>
            </Container>
        </HeroContainer>
    );
}

export const AccommodationAcquisitionInner = withTranslator(AccommodationAcquisitionInnerComponent);